import { useActionState, useEffect, useState } from "react";
import { Charity, CharityIssue } from "../../../../models";
import { Button } from "../../../../components/button";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
import CharityIssueCharityService from "../../../../services/CharityIssueCharityService";
import toast from "react-hot-toast";
import IconButton from "../../../../components/icon-button";
import { PlusIcon } from "@heroicons/react/24/outline";
import {
  createCharityIssueCharity,
  State,
} from "../actions/CharityIssueCharity";
import { useNavigate } from "react-router-dom";
import FormError from "../../../../components/form-error";
import Select from "../../../../components/select";

export default function CharityIssueCharityCreateForm({
  charity,
  charityIssues,
}: {
  charity: Charity;
  charityIssues: CharityIssue[];
}) {
  const [incidence, setIncidence] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const api = new CharityIssueCharityService();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      incidence: 0,
    },
  };
  const [state, formAction, isPending] = useActionState(
    createCharityIssueCharity,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      toast.success("Charity Issue Charity created successfully");
      navigate(
        `/admin/charities/edit/${
          charity.id
        }?reload=${Date.now()}`
      );
    }
  }, [state]);

  return (
    <form className="flex flex-1 flex-col " action={formAction}>
      <div className="flex flex-1 gap-2 items-end">
        <div className="flex flex-row gap-2">
          <Select
            id="charityIssueId"
            name="charityIssueId"
            placeholder="Select charity issue"
            items={charityIssues.map((charityIssue) => ({
              id: charityIssue.id,
              name: charityIssue.name,
            }))}
            required
            className="w-full"
            
          ></Select>
          <Input
            id="incidence"
            name="incidence"
            type="number"
            step="0.01"
            min="0"
            placeholder="Enter incidence amount"
            required
            className="max-w-64"
          />
          <input
            type="hidden"
            id="charityId"
            name="charityId"
            value={charity.id}
          />         
        </div>
        <IconButton
          label="Add Charity Issue"
          icon={PlusIcon}
          loading={isPending}
        ></IconButton>
      </div>
      <FormError id="incidence-error" message={state.errors?.incidence} />
    </form>
  );
}
